import React from 'react';
import { Modal } from 'react-bootstrap';
import WofButton from '../WofButton';
import { CarouselModalType } from '../../types';


const CarouselModal: React.FC<CarouselModalType> = ({
  img,
  description,
  btnCloseText,
  show,
  onClose,
  onHide,
}) => (
 <React.Fragment>
 	<Modal
    show={show}
    onHide={onHide}
    size="lg"
		className="image-carousel-modal"
    aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Body>
    <img src={img} alt="" />
		{description && (
			<div className="CarouselModal-modal-desc"><p dangerouslySetInnerHTML={{
												__html: description,
			}}/></div>
		)}
    </Modal.Body>
  
      <Modal.Footer>
        <WofButton
          id={"CarouselId"}
          onClick={onClose}>
          {"close"}
        </WofButton>
   </Modal.Footer>
  </Modal>
 </React.Fragment>
);

export default CarouselModal;